import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const useAuth = () => {
  return !!localStorage.getItem('token');
};

const PrivateRoute = () => {
  const auth = useAuth();
  return auth ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoute;
